"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M7 1.08c-3.37.5-5.97 3.4-5.97 6.92 0 3.87 3.13 7 6.98 7 3.52 0 6.42-2.61 6.91-6H7V1.08z", "M8 0v8h8c0-4.42-3.58-8-8-8z"];
//# sourceMappingURL=pie-chart.js.map